import React from 'react';

const If = ({ statement, children }) => {
    return statement ? React.Children.only(children) : null;
};

export default If;
